import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-asc",
  "use": "icon-asc-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-asc\"><path d=\"M648.021333 1010.688V170.666667H791.893333v501.930666l215.978667 1.621334v17.664L673.28 1010.688h-25.173333z\" fill=\"#cdcdcd\" p-id=\"1391\" /><path d=\"M360.021333 0v840.021333H215.893333V338.090667L0 336.469333v-17.664L334.848 0h25.173333z\" p-id=\"1392\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol